import { useCallback, useEffect, useState } from 'react';

export const useScrollToTop = (threshold: number = 200) => {
	const [showScrollTop, setShowScrollTop] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			setShowScrollTop(window.scrollY > threshold);
		};
		handleScroll();
		window.addEventListener('scroll', handleScroll, { passive: true });
		return () => window.removeEventListener('scroll', handleScroll);
	}, [threshold]);

	const handleScrollTop = useCallback(() => {
		window.scrollTo({ top: 0 });
	}, []);

	return { showScrollTop, handleScrollTop };
};
